// extracted by mini-css-extract-plugin
module.exports = {"title":"_582989a8"};